import React from "react";
import { Layout, NavigationBanner, SectionList } from "../../components";
import styles from "./EngenCares.module.scss";
import useFetchB2B from "../../helpers/useFetchB2B";
import b2bRoutes from "../../helpers/b2b.routes";

const EngenCares = () => {
  const { currentPage, pages } = useFetchB2B({
    url: b2bRoutes.ENGENCARES,
    mainPage: true,
  });

  return (
    <Layout pageTitle="Engen Cares" withBottomPadding={false} withScrollToTop>
      {currentPage && (
        <>
          <NavigationBanner pages={pages} activePage={currentPage} />
          <div className={styles.main}>
            <SectionList sections={currentPage.sections} />
          </div>
        </>
      )}
    </Layout>
  );
};

export default EngenCares;
